
import { SiriusBaseComponent } from 'sirius-framework';
import { Component } from '@angular/core';

@Component({
    selector: 'inner-menu-oldprocess',
    templateUrl: './inner-menu-oldprocess.component.html',
    styleUrls: ['./inner-menu-oldprocess.component.css']
})
export class InnerMenuOldProcessComponent extends SiriusBaseComponent<any> {
    constructor() {
        super();
    }
    OnInit() {

    }
}
